import { FC } from "react";

import { RidePassengerCsvListCell } from "../../grid";
import { IRenderColumnTemplate } from "./_core";

export const RidePassengerCsvListCellTemplate: FC<IRenderColumnTemplate> = ({
  value,
}) => {
  if (!value?.length) {
    return null;
  }

  return <RidePassengerCsvListCell passengersInfo={value} />;
};
